import z from 'zod';

import { AppraisalId, LosId, PropertyId } from '../../BrandedIds';
import { AppraisalMethod, AppraisalType } from '../../loan/Appraisal';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString } from '../../utils';

export const ExportableAppraisal = z
  .object({
    id: zodBrandedString<AppraisalId>(),
    loanId: zodBrandedString<LosId>(),
    propertyId: zodBrandedString<PropertyId>(),

    type: AppraisalType,
    amount: z.number().positive(),
    date: zodTemporalPlainDate,
    method: AppraisalMethod,
    orderId: z.string().optional(),
    isOriginal: z.boolean().optional(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Appraisal' });
export type ExportableAppraisal = z.infer<typeof ExportableAppraisal>;
